<mat-tab-group>
  <mat-tab *ngFor="let scope of userData.scopedClaims2user; let k = index" label="{{scope.desc}}">
    <ng-template matTabContent>
      <mat-accordion>
        <mat-expansion-panel *ngFor="let c of scope.claims; let i = index">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{c.desc}}
              <ng-container *ngIf="privateClaim(c)">
                <mat-icon class="small" matTooltip="Mitarbeiter-Zugang">perm_identity</mat-icon>
              </ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-card-content>
            <table class="mat-table data-table">
              <tr>
                <th>Id</th>
                <td>{{c.id}}</td>
              </tr>
              <tr *ngIf="c.customer_id">
                <th>Eigentümer des Zugangs</th>
                <td>
                  <a routerLink="{{'/admin/customers/edit/' + c.customer_id}}">{{c.customer_name}} <mat-icon class="small">edit</mat-icon></a>
                </td>
              </tr>
              <tr>
                <th>Kundenummer</th>
                <td>{{c.external_customer_id}}</td>
              </tr>
              <tr>
                <th>Zugangsnummer</th>
                <td>{{c.external_claim_id}}</td>
              </tr>
              <tr>
                <th>Gültig von</th>
                <td> {{c.start | date:'short'}}</td>
              </tr>
              <tr>
                <th>Gültig bis</th>
                <td> {{c.expires | date:'short'}}</td>
              </tr>
            </table>

            <div class="actions">
              <button (click)="deleteClaim2User(c, k, i)" mat-raised-button color="warn">Löschen
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-card-content>

        </mat-expansion-panel>
      </mat-accordion>
    </ng-template>
  </mat-tab>
</mat-tab-group>
